// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__35HzS","emails":"CreateEditClinics_emails__32rpO","emailTagLabel":"CreateEditClinics_emailTagLabel__CzMdi"};